import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import React, { useContext } from "react";
import { AuthContext, AuthProvider } from "./AuthContext";
import Login from "./Login";
import EmployeeList from "./EmployeeList";
import EditPage from "./EditPage";

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<EmployeeList />} />
          <Route path="/login" element={<Login />} />
          <Route path="/edit" element={<ProtectedRoute><EditPage /></ProtectedRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
